import { makeStyles } from "@material-ui/core"
import React, { FC } from "react"
import { colors } from "../../../utils/theme"
import { H1 } from "../../atoms/typography/Typography"

const useStyles = makeStyles((theme) => ({
  card: {
    display: "flex",
    flexDirection: "column",
    width: 400,
    backgroundColor: colors.neutral.white,
    borderRadius: 4,
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: colors.neutral.clay,
    padding: theme.spacing(5),
    position: "relative",
    zIndex: 2,
  },
  title: {
    paddingBottom: theme.spacing(2),
  },
}))
export interface TitledCardProps {
  title: string
  children: React.ReactNode
}
export const TitledCard: FC<TitledCardProps> = ({ title, children }) => {
  const classes = useStyles()
  return (
    <div className={classes.card}>
      <H1 className={classes.title}>{title}</H1>
      {children}
    </div>
  )
}
